import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * Fires a `page_view` analytics event whenever the React Router location
 * pathname changes. Mount this once inside the Router tree (e.g. via a
 * <PageViewTracker /> component that returns null).
 */
export function usePageView(): void {
  const location = useLocation();
  useEffect(() => {
    const title = typeof document !== 'undefined' ? document.title : undefined;
    trackPageView(location.pathname, title);
  }, [location.pathname]);
}
